import {
    FETCH_DELETE_PRODUCTS_REQUEST,
    FETCH_DELETE_PRODUCTS_SUCCESS,
    FETCH_DELETE_PRODUCTS_FAILURE,
} from '../../actions/products/delete-product-action';

const initialState = {
    removed: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const DeleteProductReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DELETE_PRODUCTS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DELETE_PRODUCTS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                removed: action.payload || true,
            };
        case FETCH_DELETE_PRODUCTS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default DeleteProductReducer;